import moment from 'moment-timezone'

const timeZone = moment.tz.guess()

const timeZoneAbbrs = {
  EST: 'ET',
  EDT: 'ET',
  CST: 'CT',
  CDT: 'CT',
  MST: 'MT',
  MDT: 'MT',
  PST: 'PT',
  PDT: 'PT',
}

export {
  timeZone,
  timeZoneAbbrs
}
